import React, { useEffect } from "react";
import { trendingCategoryData } from "../../data/categories_data";
import Collection_category_filter from "../collectrions/collection_category_filter";
import CategoryItem from "./categoryItem";
import { useDispatch } from "react-redux";
import { updateTrendingCategoryItemData } from "../../redux/counterSlice";
import RenderGroup from "../campaigns/category_ui";
import { collectionDropdown2_data } from "../../data/dropdown";
import Tippy from "@tippyjs/react";
import Collection_dropdown2 from "../dropdown/collection_dropdown2";
import Collection_icons from "../dropdown/collection_icons";
import Image from "next/image";
import { useState } from "react";
import { campaignFilter } from "../../redux/apiSlice";
const top100Films = [
  { title: "The Shawshank Redemption", year: 1994 },
  { title: "The Godfather", year: 1972 },
  { title: "The Godfather: Part II", year: 1974 },
  { title: "The Dark Knight", year: 2008 },
  { title: "12 Angry Men", year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: "Pulp Fiction", year: 1994 },
];

const FilterCategoryItem = () => {
  const dispatch = useDispatch();
  const [priceRange, setPriceRange] = useState({
    min: 0,
    max: 0,
    status: "All",
  });
  useEffect(() => {
    dispatch(updateTrendingCategoryItemData(trendingCategoryData.slice(0, 8)));
  }, [dispatch]);
  const data_status = [
    {
      id: 0,
      text: "All",
      image: "/images/avatars/collection_ava_1.png",
    },
    {
      id: 1,
      text: "Available",
      image: "/images/avatars/collection_ava_1.png",
    },
    {
      id: 2,
      text: "Sold",
      image: "/images/avatars/collection_ava_1.png",
    },
  ];

  useEffect(() => {
    dispatch(campaignFilter(priceRange));
  }, [priceRange]);

  return (
    <div>
      {/* <!-- Filter --> */}
      {/* <Collection_category_filter /> */}

      {/* <RenderGroup top100Films={top100Films} /> */}
      <div className="flex flex-col md:flex-row">
        <div className="w-full md:w-1/3 p-4">
          <div className="relative">
            <div>
              {/* filter-Icon.svg */}
              <label className="ml-1 font-display text-jacarta-700 mb-2 block dark:text-white">
                {/* <Image
                  src="/images/filter-Icon.svg"
                  className="mr-2.5 inline-block h-6 w-6 object-contain text-white"
                  alt="icon"
                  height={24}
                  width={24}
                /> */}
                Filter Impact DOT
              </label>
            </div>

            {/* dropdown */}
            <div className="dropdown my-1 cursor-pointer">
              <Collection_dropdown2
                setPriceRange={setPriceRange}
                priceRange={priceRange}
                data={data_status}
                collection={true}
              />
            </div>
          </div>
        </div>
        <div className="w-full md:w-1/3 p-4">
          <div className="relative">
            <div>
              <label className="font-display text-jacarta-700 mb-2 block dark:text-white">
                Min Price
              </label>
              <input
                type="number"
                id="item-name"
                className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
                placeholder="Min Price"
                required
                disabled={priceRange.status == "All" ? "disabled" : ""}
                onChange={(e) =>
                  setPriceRange({ ...priceRange, min: e.target.value })
                }
              />
            </div>

            {/* dropdown */}
            <div className="dropdown my-1 cursor-pointer"></div>
          </div>
        </div>
        <div className="w-full md:w-1/3 p-4">
          <div className="relative">
            <div>
              <label className="font-display text-jacarta-700 mb-2 block dark:text-white">
                Max Price
              </label>
              <input
                type="text"
                id="item-name"
                className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
                placeholder="Max Price"
                required
                disabled={priceRange.status == "All" ? "disabled" : ""}
                onChange={(e) =>
                  setPriceRange({ ...priceRange, max: e.target.value })
                }
              />
            </div>

            {/* dropdown */}
            <div className="dropdown my-1 cursor-pointer"></div>
          </div>
        </div>
      </div>

      <CategoryItem />
    </div>
  );
};

export default FilterCategoryItem;
